const fontContent = {
  text: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum sem purus, dictum vitae lorem quis, pellentesque pulvinar augue. Sed quis ex cursus, tincidunt erat a, consequat dolor. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Ut sit amet consequat mauris, quis suscipit dolor. Maecenas odio nisi, pellentesque quis tincidunt sed, suscipit vitae justo. In porta nibh eu quam hendrerit lobortis. Nam ac interdum quam. In pretium sem ut nunc tincidunt, quis placerat ante hendrerit. Fusce a eleifend turpis. Nam blandit rutrum odio ultricies porta. Phasellus varius et massa a porttitor. `,
  a00: {
    tag: "h4",
    title: "h4, font-size:24px, color: #212529",
  },
  a01: {
    tag: "h4",
    class: "text-success",
    title: "h4, font-size:24px, color: #28a745",
  },
  a02: {
    tag: "h4",
    style: { color: "#0774f2" },
    title: "h4, font-size:24px, color: #0774f2",
  },
  a03: {
    tag: "h4",
    style: { color: "#3489f4" },
    title: "h4, font-size:24px, color: #3489f4",
  },
  a04: {
    tag: "h4",
    style: { color: "#62BFF9" },
    title: "h4, font-size:24px, color: #62BFF9",
  },
  a05: {
    tag: "h4",
    class: "text-danger",
    title: "h4, font-size:24px, color: #dc3545",
  },
  a11: {
    tag: "div",
    style: { color: "#16181b" },
    title: "font-size:16px, color: #16181b",
  },
  a12: {
    tag: "strong",
    title: "strong, font-size:16px, color: #212529",
  },
  a13: {
    tag: "small",
    pre: {
      tag: "div",
      class: "text-muted",
    },
    title: "font-size:14.4px, color: #6c757d",
  },
  a14: {
    tag: "small",
    background: "popup-top-bar",
    pre: {
      tag: "div",
      class: "p-2 sub-title-light",
    },
    title: "font-size:14.4px, color: #e9ecef, background: #40454C",
  },
  a15: {
    tag: "strong",
    // mid: "small",
    pre: {
      tag: "div",
      class: "text-muted",
    },
    title: "font-size:14.4px, color: #6c757d",
  },
  a21: {
    tag: "div",
    panelStyle: { backgroundColor: "#337ab7" },
    style: { color: "#ffffff" },
    title: "font-size:16px, color: #ffffff",
  },
  a22: {
    tag: "div",
    panelStyle: { backgroundColor: "#337ab7" },
    style: { color: "#ffffff", fontSize: "14px" },
    title: "font-size:14px, color: #ffffff",
  },
  a23: {
    tag: "strong",
    panelStyle: { backgroundColor: "#337ab7" },
    style: { color: "#ffffff", fontSize: "16px" },
    title: "font-size:16px, color: #ffffff, background: #337ab7",
  },
  a24: {
    tag: "div",
    class: "text-danger",
    title: "font-size:16px, color: Danger - #dc3545",
  },
  a25: {
    tag: "div",
    class: "text-warning",
    title: "font-size:16px, color: Warning - #ffc107",
  },
  a26: {
    tag: "div",
    class: "text-success",
    title: "font-size:16px, color: Success - #28a745",
  },
  a27: {
    tag: "div",
    background: "popup-top-bar",
    pre: {
      tag: "div",
      class: "p-2 text-light",
    },
    title: "font-size:16px, color: #f8f9fa, background: #40454C",
  },
  a28: {
    tag: "strong",
    class: "text-danger",
    pre: {
      tag: "small",
      // class: "text-muted",
    },
    title: "strong, font-size:14.4px, color: Danger - #dc3545",
  },
  a29: {
    tag: "strong",
    class: "text-warning",
    pre: {
      tag: "small",
      // class: "text-warning",
    },
    title: "strong, font-size:14.4px, color: Warning - #ffc107",
  },
  a30: {
    tag: "strong",
    class: "text-success",
    pre: {
      tag: "small",
      // class: "text-success",
    },
    title: "strong, font-size:14.4px, color: Success - #28a745",
  },
  a31: {
    tag: "strong",
    class: "text-light",
    background: "popup-top-bar",
    pre: {
      tag: "div",
    },
    title: "strong, font-size:16px, color: #e9ecef, background: #40454C",
  },
  a32: {
    tag: "h4",
    class: "text-light",
    background: "popup-top-bar",
    pre: {
      tag: "div",
    },
    title: "h4, font-size:24px, color: #e9ecef, background: #40454C",
  },
  a33: {
    tag: "h5",
    title: "h5, font-size:20px, color: #e9ecef",
  },
  a34: {
    tag: "h2",
    title: "h2, font-size:32px, color: #e9ecef",
  },
  a35: {
    background: "diag-bg",
    pre: {
      tag: "div",
      // class: "diag-bg",
    },
    tag: "h5",
    title: "h5, font-size:20px, color: #721c24",
  },
  a36: {
    background: "maintenance-bg",
    pre: {
      tag: "div",
      // class: "maintenance-bg",
    },
    tag: "h5",
    title: "h5, font-size:20px, color: #72431c",
  },
  a37: {
    background: "working-bg",
    pre: {
      tag: "div",
      // class: "working-bg",
    },
    tag: "h5",
    title: "h5, font-size:20px, color: #135713",
  },
  a38: {
    background: "diag-bg",
    pre: {
      tag: "div",
      // class: "working-bg",
    },
    tag: "strong",
    title: "strong, font-size:16px, color: #721c24",
  },
  a39: {
    background: "maintenance-bg",
    pre: {
      tag: "div",
      // class: "maintenance-bg",
    },
    tag: "strong",
    title: "strong, font-size:16px, color: #72431c",
  },
  a40: {
    background: "working-bg",
    pre: {
      tag: "div",
      // class: "working-bg",
    },
    tag: "strong",
    title: "strong, font-size:16px, color: #135713",
  },
};

export default fontContent;
